import { FORMAT_IDS, DEPRICATED_FORMAT_IDS } from 'types/deck'

import { LegalityChecker, DeckLeglaity } from '../deckLegality'
import { ERRORS } from '../legality.const'

const CheckLegality: LegalityChecker = (deck: DeckLeglaity) => {
  const formatName = FORMAT_IDS[deck.format] || DEPRICATED_FORMAT_IDS[deck.format]
  const fullDeck = [...deck.mainboard, ...deck.sideboard]

  for (const card of fullDeck) {
    deck.checkCardLegality(card)
    deck.checkCardQuantity(card)

    const cardLegality = card.legalities[formatName]

    if (cardLegality === 'restricted' && deck.cardQuantities[card.name] > 1) deck.addCardError(ERRORS.RESTRICTED, card)
  }

  if (deck.sideboardSize > 15) deck.addError(ERRORS.SIDEBOARD_SIZE)
  if (deck.deckSize < 60) deck.addError(ERRORS.DECK_SIZE)
}

export default CheckLegality
